import React, { useEffect } from 'react';


function Header(props) {
    let add =props.isFixed === true ? " nav-fixed" : "";
    let clazz = "fixed-top" + add;

    let logoSrc = props.isFixed === true ? "assets/images/logo-black.png" : "assets/images/logo.png";

    useEffect(() => {
        const toggle = document.getElementById('navbarServicesDropdown');
        if (!toggle) return undefined;

        const mq = window.matchMedia('(min-width: 992px)');

        const updateToggle = () => {
            if (mq.matches) {
                toggle.removeAttribute('data-toggle');
            } else {
                toggle.setAttribute('data-toggle', 'dropdown');
            }
        };

        const handleClick = (e) => {
            if (mq.matches) {
                e.preventDefault();
            }
        };

        updateToggle();
        mq.addEventListener('change', updateToggle);
        toggle.addEventListener('click', handleClick);
        return () => {
            mq.removeEventListener('change', updateToggle);
            toggle.removeEventListener('click', handleClick);
        };
    }, []);

    return (
        <header id="site-header" className={clazz}>
            <div className="nav-info-bar" style={{textAlign:"center"}}>
                <a href="tel:+19145641865" class="nav-info-bar-item">
                    <span class="fas fa-phone" style={{marginRight: "4px"}}></span><span>(914) 564-1865</span>
                </a>
                <span className="nav-info-bar-splitter">|</span>
                <a className="rm-pointer">
                    <span class="fas fa-globe" style={{marginRight: "4px"}}></span><span>Hawthorne, NY</span>
                </a>
            </div>

            <div className="container mt-lg-1">
                <nav className="navbar navbar-expand-lg stroke px-0 pt-lg-0">
                    <a className="navbar-brand" href="/">
                        <img alt="Main logo" id="main-logo" src={logoSrc} width="250px" />
                    </a>
                    <button className="navbar-toggler  collapsed bg-gradient" type="button" data-toggle="collapse"
                        data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon fa icon-expand fa-bars"></span>
                        <span className="navbar-toggler-icon fa icon-close fa-times"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
                        <ul className="navbar-nav mr-lg-auto">
                            <li className="nav-item">
                                <a className="nav-link" href="/">Home <span className="sr-only">(current)</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/team">Team</a>
                            </li>
                            <li className="nav-item dropdown">
                                <a
                                    className="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarServicesDropdown"
                                    role="button"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                >
                                    Services
                                </a>
                                <div className="dropdown-menu" aria-labelledby="navbarServicesDropdown">
                                    <a className="dropdown-item" href="/services">All Services</a>
                                    <a className="dropdown-item" href="/services/network-infrastructure">Network Infrastructure</a>
                                    <a className="dropdown-item" href="/services/storage-and-backup">Storage &amp; Backup</a>
                                    <a className="dropdown-item" href="/services/domains-dns-integrations">Domains, DNS &amp; Integrations</a>
                                </div>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="/contact">Contact</a>
                            </li>
                        </ul>

                        

            
                    </div>
                    

                </nav>
            </div>
        </header>
    );
}

export default Header;